/**
 * src/components/common/NightSky.jsx
 * در تم دارک: AtariBackground با opacity
 * در تم لایت: پس‌زمینه روشن با gradient ملایم — بدون ستاره
 */
import React, { useEffect, useState } from "react";
import AtariBackground from "./AtariBackground";

const NightSky = ({ density = "medium", dim = false }) => {
  const [isDark, setIsDark] = useState(
    () => (localStorage.getItem("bb_theme") || "dark") === "dark"
  );

  useEffect(() => {
    // گوش دادن به تغییر data-theme روی documentElement
    const observer = new MutationObserver(() => {
      const theme = document.documentElement.getAttribute("data-theme");
      setIsDark(theme !== "light");
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  // ── تم لایت ──────────────────────────────────────────────────
  if (!isDark) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 0,
          background: `
            radial-gradient(ellipse at 20% 50%, rgba(147, 197, 253, 0.25) 0%, transparent 60%),
            radial-gradient(ellipse at 80% 20%, rgba(196, 181, 253, 0.2) 0%, transparent 55%),
            radial-gradient(ellipse at 60% 80%, rgba(167, 243, 208, 0.2) 0%, transparent 55%),
            radial-gradient(ellipse at 40% 30%, rgba(251, 207, 232, 0.15) 0%, transparent 50%),
            linear-gradient(135deg, #e8f4ff 0%, #f0ebff 40%, #e8fff4 70%, #fff0f8 100%)
          `,
          pointerEvents: "none",
        }}
      >
        {/* نقاط تزئینی ملایم به جای ستاره */}
        {[...Array(18)].map((_, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              width: i % 3 === 0 ? 8 : i % 3 === 1 ? 5 : 3,
              height: i % 3 === 0 ? 8 : i % 3 === 1 ? 5 : 3,
              borderRadius: "50%",
              background: [
                "rgba(99,102,241,0.2)",
                "rgba(16,185,129,0.2)",
                "rgba(236,72,153,0.2)",
                "rgba(59,130,246,0.2)",
              ][i % 4],
              top: `${(i * 17 + 5) % 90}%`,
              left: `${(i * 23 + 10) % 95}%`,
              filter: "blur(1px)",
            }}
          />
        ))}
      </div>
    );
  }

  // ── تم دارک — همان AtariBackground قبلی ────────────────────
  return (
    <div
      style={{
        opacity: dim ? 0.55 : 0.75,
        zIndex: 0,
      }}
    >
      <AtariBackground />
    </div>
  );
};

export default NightSky;